module.exports = __webpack_public_path__ + "img/0.eab3187f.jpg";